import { render } from "./PrintQuotePage.vue?vue&type=template&id=34b694ce&scoped=true&ts=true"
import script from "./PrintQuotePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrintQuotePage.vue?vue&type=script&setup=true&lang=ts"

import "./PrintQuotePage.vue?vue&type=style&index=0&id=34b694ce&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b694ce"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/print-page/PrintQuotePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34b694ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34b694ce', __exports__)) {
    api.reload('34b694ce', __exports__)
  }
  
  module.hot.accept("./PrintQuotePage.vue?vue&type=template&id=34b694ce&scoped=true&ts=true", () => {
    api.rerender('34b694ce', render)
  })

}


export default __exports__